<div class="container-fluid ptCustom">
    <div class="my-2">
        <a [routerLink]="['/admin-portal/chamber/super-admin-member-management']" class="text-white"><i
                class="fa-regular fa-angle-left"></i> back to all members</a>
    </div>
    <div class="row">
        <div class="col-lg-4 col-md-4 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Member Liaison</h4>
                            <a href="javascript:void(0);" (click)="openEditLiaisonModal()"><i
                                    class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Liaison Name</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{liaison.fullName}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Liaison Email</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{liaison.emailAddress}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Liaison Phone</span>
                                </div>
                                <div class="dataOutput">
                                    <span mask="(000) 000-0000">{{liaison.phoneNumber}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Job Title</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{liaison.jobTitle}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Referred By</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{liaison.referredByString}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Membership</h4>
                            <a href="javascript:void(0);" (click)="openEditCompanyPaymentInfoModal()"><i
                                    class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Membership Level</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{company.membershipLevelString}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Renewal Month</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{company.membershipExpirationString}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Payment Type</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{company.paymentTypeString}}</span>
                                </div>
                            </div>
                            <!--<div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Auto-renew</span>
                                </div>
                                <div class="dataOutput">
                                    <span *ngIf="!company.autoRenew">No</span>
                                    <span *ngIf="company.autoRenew">Yes</span>
                                </div>
                            </div>-->
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Total</span>
                                </div>
                                <div class="dataOutput">
                                    <span>{{company.totalBillingDue}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 col-md-8 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Company Information</h4>
                            <a href="javascript:void(0);" (click)="openEditCompanyInfoModal()"><i
                                    class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Company/Organization Name</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.companyName}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span># Employees in 10 county region</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.numberOfEmployeesString}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Business Phone</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.businessPhone}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Business Address</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.primaryStreet}}, {{company.primaryCity}},
                                                {{company.primaryState}} {{company.primaryZip}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Business Self-Identifies as...</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.selfIdentitiesString}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Minority-owned certifications</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.certificateTypesString}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="company.brokerName != null">
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Broker Name</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.brokerName}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Broker Email</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.brokerEmail}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--structure-->
                            <div class="row">
                                <div class="detailsBlock col-auto">
                                    <div class="dataLabel">
                                        <span>Location Limit</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span>{{company.locationLimit}}</span>
                                    </div>
                                </div>
                                <!--structure-->
                                <div class="detailsBlock col-auto">
                                    <div class="dataLabel">
                                        <span>Industry</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span>{{company.industry}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detailsContainer" *ngIf="company.membershipLevel != 12">
                        <div class="detailsHeader">
                            <h4>Directory Information</h4>
                            <a href="javascript:void(0);" (click)="openEditCompanyDirectoryInfoModal()"><i
                                    class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Company/Organization Description</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span [innerHTML]="company.description"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Current Logo</span>
                                        </div>
                                        <div class="dataOutput logoPreview">
                                            <img src="{{company.logoUrl}}" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Show Liaison Info</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.isLiaisonOptedIn ? "Yes" : "No"}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Company/Organization Website</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{company.website}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detailsContainer" *ngFor="let address of addresses;">
                        <div class="detailsHeader">
                            <h4>{{address.locationName}}</h4>
                            <a href="javascript:void(0);" (click)="openAddEditAddressInfoModal(false, address)"><i
                                    class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Address</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{address.street}}, {{address.city}}, {{address.state}}
                                                {{address.zip}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Notes</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{address.notes}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Email Address</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{address.locationEmail}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Phone Number</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{address.locationPhone}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div *ngIf="company.locationLimit > (addresses.length + 1)" class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Additional Addresses</h4>
                        </div>
                        <div class="detailsSection">
                            <div class="row align-items-center">
                                <div class="col">
                                    <span>You have {{company.locationLimit - (addresses.length + 1)}} more address(es)
                                        available to use in your membership</span>
                                </div>
                                <div class="col-auto">
                                    <a href="javascript:void(0);" (click)="openAddEditAddressInfoModal(true)"
                                        type="button" class="btn btn-add text-strong hvr-grow"><i
                                            class="fa-solid fa-plus"></i> new address</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>